
import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { AlertTriangle } from 'lucide-react';
import { Page } from '@/types/crawler';
import { Alert, AlertDescription } from '@/components/ui/alert';

interface AnalysisControlsProps {
  urlInput: string;
  setUrlInput: (url: string) => void;
  handleAnalyze: (page?: Page) => void;
  selectedPageObj: Page | null;
  isAnalyzing: boolean;
}

export const AnalysisControls: React.FC<AnalysisControlsProps> = ({
  urlInput,
  setUrlInput,
  handleAnalyze,
  selectedPageObj,
  isAnalyzing
}) => {
  return (
    <div className="neo-card rounded-xl p-6 space-y-4 border-primary/20">
      <div className="flex flex-wrap gap-4 items-end">
        <div className="flex-1 min-w-[300px]">
          <label htmlFor="url-input" className="block text-sm font-medium mb-2 text-foreground">
            URL
          </label>
          <div className="relative">
            <Input
              id="url-input"
              placeholder="Enter URL to analyze"
              value={urlInput}
              onChange={(e) => setUrlInput(e.target.value)}
              className="w-full border-primary/20 focus-visible:ring-primary/30 bg-secondary/70"
            />
          </div>
        </div>
        
        <Button
          onClick={() => handleAnalyze()}
          disabled={isAnalyzing || !urlInput}
          className="whitespace-nowrap bg-primary hover:bg-primary/90 text-primary-foreground shadow-md transition-all duration-200"
        >
          {isAnalyzing ? 'Analyzing...' : 'Analyze'}
        </Button>
      </div>
      
      {selectedPageObj && (
        <div className="pt-2">
          <Alert variant="default" className="bg-primary/10 border-primary/20">
            <AlertTriangle className="h-4 w-4 text-primary" />
            <AlertDescription className="text-sm">
              Selected page: {selectedPageObj.url} ({selectedPageObj.wordCount || 'Unknown'} words)
            </AlertDescription>
          </Alert>
        </div>
      )}
    </div>
  );
};
